import { render, staticRenderFns } from "./DocumentOpmerkingen.vue?vue&type=template&id=2079c39a"
import script from "./DocumentOpmerkingen.vue?vue&type=script&lang=js"
export * from "./DocumentOpmerkingen.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports